import { loadStripe } from "@stripe/stripe-js";
import { CheckoutSectionCardHeader } from "components/Step/StepPrimitives";
import { useEffect, useRef, useState } from "react";
import styled from "styled-components";

const SeparatorText = styled.div`
  text-align: center;
  margin-top: 1rem;
  color: #666;
  font-size: 0.9rem;
`;

const stripePromise = loadStripe(
  process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY!
);

type CheckoutExpressElementProps = {
  amount: string;
  onToken: (token: { token: string }) => void;
  onError: (error: string) => void;
};

const CheckoutExpressElement = ({
  amount,
  onToken,
  onError,
}: CheckoutExpressElementProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    const mountButton = async () => {
      const stripe = await stripePromise;
      if (!stripe || !ref.current) return;

      const paymentRequest = stripe.paymentRequest({
        country: "US",
        currency: "usd",
        total: {
          label: "Total",
          amount: Math.round(parseFloat(amount.replace("$", "")) * 100),
        },
        requestPayerName: true,
        requestPayerEmail: true,
      });

      const elements = stripe.elements();
      const prButton = elements.create("paymentRequestButton", {
        paymentRequest,
        style: {
          paymentRequestButton: {
            type: "default",
            theme: "dark",
            height: "40px",
          },
        },
      });

      const result = await paymentRequest.canMakePayment();
      if (result) {
        prButton.mount(ref.current);
        setMounted(true);
      } else {
        console.warn("Google Pay / Apple Pay not available");
        return;
      }

      paymentRequest.on("token", async (event) => {
        try {
          await onToken({ token: event.token.id });
          event.complete("success");
        } catch (err: any) {
          onError("Payment failed");
          event.complete("fail");
        }
      });

      paymentRequest.on("cancel", () => {
        onError("Payment canceled");
      });
    };

    mountButton();
  }, [amount]);

  return (
    <div style={{ display: mounted ? "block" : "none" }}>
      <CheckoutSectionCardHeader css={"margin: 0 0 .5rem"}>
        Express Checkout
      </CheckoutSectionCardHeader>
      <div id="stripe-express-checkout" ref={ref} />
      <SeparatorText>– or –</SeparatorText>
    </div>
  );
};

export default CheckoutExpressElement;
